import React, { Fragment, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SecurityContextHolder } from 'core.ui-module_site-security';

const Welcome = () => {
  const [page, setPage] = useState(window.location.href);

  const filterCallBack = (e) => {
    try {
      if (e?.data?.additionalData?.header === 'Logout Successful!') {
        setPage(window.location.href)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`ERROR in post message listener ${error}`);
    }
  };

  useEffect(() => {
    window.addEventListener('message', filterCallBack);
    return () => window.removeEventListener('message', filterCallBack);
  },[window.location.href]);
  
  return(
  <Fragment>
    <div className="slge-welcome is-flex">
      <NavLink to="/media-center" activeClassName="is-active" className="navbar-item pl-0 pr-2">
        Media Inquiries
      </NavLink>
      <NavLink to="/about/contact-us" activeClassName="is-active" className="navbar-item pl-3">
        Contact Us
      </NavLink>
      {SecurityContextHolder.isAuthenticated() && 
      (<NavLink to="/content_maintenance" activeClassName="is-active" className="navbar-item pl-3">
        Content Maintenance
      </NavLink>)}
    </div>
  </Fragment>)
};
export default Welcome;
